import React, { useRef, useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FiChevronRight } from "react-icons/fi";

const CTPopupMenu = ({
  x,
  y,
  options = [],
  onSelect,
  onClose,
  parentWidth = 0,
}) => {
  const menuRef = useRef(null);
  const [pos, setPos] = useState({ left: x, top: y });
  const [visible, setVisible] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  // Hacer aparecer el menú suavemente
  useEffect(() => {
    const id = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(id);
  }, []);

  // Cerrar al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setVisible(false);
        setTimeout(() => onClose?.(), 200);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  // Ajuste de posición para que no se salga del viewport
  useLayoutEffect(() => {
    const menu = menuRef.current;
    if (!menu) return;
    const { innerWidth, innerHeight } = window;
    const rect = menu.getBoundingClientRect();
    let newLeft = x;
    let newTop = y;

    // Ajuste horizontal: si no cabe a la derecha, abrir a la izquierda
    if (x + rect.width > innerWidth) {
      newLeft = Math.max(8, x - rect.width - parentWidth);
    }

    // Ajuste vertical: no salir por abajo
    if (y + rect.height > innerHeight) {
      newTop = Math.max(8, innerHeight - rect.height - 8);
    }

    if (newLeft !== pos.left || newTop !== pos.top) {
      setPos({ left: newLeft, top: newTop });
    }
  }, [x, y, pos.left, pos.top, options, parentWidth]);

  if (!options.length) return null;

  const menuContent = (
    <ul
      ref={menuRef}
      className={`fixed z-[10001] ct-popup p-2 min-w-[180px] list-none
        transform transition-all duration-200 ease-out space-y-1
        ${visible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
      style={{ top: pos.top, left: pos.left }}
    >
      {options.map((option) =>
        option.CAPTION === "-" ? (
          <li key={option.INTER || Math.random()} className="ct-popup-separator" />
        ) : (
          <li
            key={option.INTER}
            className="relative"
            onMouseEnter={() => setOpenSubmenu(option.INTER)}
            onMouseLeave={() => setOpenSubmenu(null)}
          >
            <button
              className={`w-full px-3 py-2 text-left rounded-md text-base flex justify-between items-center
                ${option.DEFECTE === "X" ? "font-semibold" : "font-normal"}
                ${option.disabled ? "ct-popup-item-disabled" : "ct-popup-item"}`}
              onClick={(e) => {
                e.preventDefault();
                if (!option.disabled && !option.submenu) onSelect(option, e);
              }}
            >
              <span>{option.CAPTION}</span>
              {option.submenu && (
                <FiChevronRight className="ml-2 text-gray-400 dark:text-gray-300" />
              )}
            </button>

            {option.submenu && openSubmenu === option.INTER && (
              <CTPopupMenu
                x={
                  pos.left +
                  (pos.left + 180 > window.innerWidth ? -180 - parentWidth : 180)
                }
                y={pos.top}
                options={option.submenu}
                onSelect={onSelect}
                onClose={() => setOpenSubmenu(null)}
                parentWidth={180}
              />
            )}
          </li>
        )
      )}
    </ul>
  );

  return createPortal(menuContent, document.body);
};

export default CTPopupMenu;
